// extracted by mini-css-extract-plugin
module.exports = {"htmlDiv":"EditInput_htmlDiv_2ADN8"};